
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAaQdY7-3xq2E-I-3lOfLZzInpanzQPIuk",
  authDomain: "schoolwerk-468705.firebaseapp.com",
  projectId: "schoolwerk-468705",
  storageBucket: "schoolwerk-468705.firebasestorage.app",
  messagingSenderId: "1005971273945",
  appId: "1:1005971273945:web:062ee4dba60a9c6316a6c8",
  measurementId: "G-RELVGEMDDQ"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

export { app, analytics, auth };
